<script lang="ts" setup>
const { value } = defineProps<{
  value: number
  expenseLabel: string
  lowLabel?: string
  acceptableLabel?: string
  highLabel?: string
  veryHighLabel?: string
}>()

const circleClass = computed(() => {
  switch (value) {
    case 1:
      return 'bg-[#28BF28] left-0'
    case 2:
      return 'bg-[#FFCD0D] left-4/11'
    case 3:
      return 'bg-[#F06706] left-3/5'
    case 4:
      return 'bg-[#CC0000] right-0'
    default:
      return 'bg-[#CC0000] right-0'
  }
})
</script>

<template>
  <div class="flex flex-col gap-1">
    <span>{{ expenseLabel }}</span>
    <div class="mt-2 relative w-full h-2 bg-gradient-to-r rounded-2xl" style="background: var(--new-shade, linear-gradient(270deg, #C00 0%, #F06706 32.36%, #FFCD0D 68.71%, #0ACC58 99.58%));">
      <div class="absolute top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full" :class="circleClass" />
    </div>
    <div class="flex text-sm w-full">
      <span class="w-1/4" :class="{ 'text-[#28BF28]': value === 1 }">{{ lowLabel }}</span>
      <span class="w-1/4 text-center" :class="{ 'text-[#FFCD0D]': value === 2 }">{{ acceptableLabel }}</span>
      <span class="w-1/4 text-center" :class="{ 'text-[#F06706]': value === 3 }">{{ highLabel }}</span>
      <span class="w-1/4 text-right" :class="{ 'text-[#CC0000]': value === 4 }">{{ veryHighLabel }}</span>
    </div>
  </div>
</template>
